/**
 * 구독 관리 API
 * FSD: features/subscription/subscription-manage/api
 */

import { apiClient } from '@/shared/api/client';
import type { Subscription, BillingHistory } from '@/entities/subscription/model';

class SubscriptionAPI {
  async getActiveSubscription(): Promise<Subscription> {
    try {
      const response = await apiClient.get('/v1/payment/subscription/active');
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '활성 구독 조회 실패');
    }
  }

  async getSubscriptionBillingHistory(subscriptionId: string): Promise<BillingHistory> {
    try {
      const response = await apiClient.get(`/v1/payment/subscription/${subscriptionId}/history`);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '결제 내역 조회 실패');
    }
  }

  async pauseSubscription(subscriptionId: string, reason?: string) {
    try {
      const response = await apiClient.post('/v1/payment/subscription/pause', {
        subscription_id: subscriptionId,
        reason,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '구독 일시중지 실패');
    }
  }

  async resumeSubscription(subscriptionId: string) {
    try {
      const response = await apiClient.post('/v1/payment/subscription/resume', {
        subscription_id: subscriptionId,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '구독 재개 실패');
    }
  }

  async cancelSubscription(subscriptionId: string, reason?: string) {
    try {
      const response = await apiClient.post('/v1/payment/subscription/cancel', {
        subscription_id: subscriptionId,
        reason,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '구독 취소 실패');
    }
  }
}

export const subscriptionAPI = new SubscriptionAPI();
